interface Props {
  className?: string;
  isEnabled: boolean;
}

const Switch: React.FC<Props> = ({ className, isEnabled }) => {
  return (
    <>
      {isEnabled ? (
        <div className="flex justify-end p-1 bg-[#4285F4] w-[45px] h-[27.5px] rounded-full">
          <div className="bg-white rounded-full h-full aspect-[1/1]"></div>
        </div>
      ) : (
        <div className="p-1 bg-gray-500 w-[45px] h-[27.5px] rounded-full">
          <div className="bg-white rounded-full h-full aspect-[1/1]"></div>
        </div>
      )}
    </>
  );
};

export default Switch;
